module.exports = __webpack_public_path__ + "media/7.ce4223e0.mp3";